module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/discover-ce8cc22a51c2897f3606766bac30455b.png";